
/**
 * 订单管理路由
 * @Description: 商品管理模块路由及完整子路由
 *
 * @Author: JZT.Oscar
 * @Date: 2018-10-12 08:57:14
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-03-05 10:17:01
 */
export default [

    {

        path: "/orderManage/orderList",
        name: "订单列表",
        component: () => import("@/pages/orderManage/orderList"),
        icon: "none",
        meta: {
            comName: "orderList",
            needRefresh: true
        }
    },
    {
        path: "/orderManage/orderDetails",
        name: "订单详情",
        component: () => import("@/pages/orderManage/orderDetails"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "orderDetails"
        }
    },
    {
        path: "/orderManage/refundReview",
        name: "退款审核" ,
        component: () => import("@/pages/orderManage/refundReview"),
        icon: "none",
        meta: {
            comName: "refundReview",
            needRefresh: true
        }
    }

];



// WEBPACK FOOTER //
// ./src/router/order.js